// Each pose follows the same stitch: insert, catch yarn, draw through, tighten.
const poses = [
  { p: 0, x: 149, y: 206, angle: -24 },
  { p: 0.22, x: 143, y: 213, angle: -11 },
  { p: 0.4, x: 142, y: 212, angle: -30 },
  { p: 0.64, x: 151, y: 203, angle: -29 },
  { p: 0.83, x: 153, y: 204, angle: -16 },
  { p: 1, x: 149, y: 206, angle: -24 },
];

export function animateCrocheting(lady, paused) {
  const get = (selector) => lady.querySelector(selector);
  const support = get(".support-wrist");
  const hand = get(".tool-wrist");
  const tool = get(".tool");
  const blanket = get(".blanket");
  const loop = get(".hook-loop");
  const limbs = Object.fromEntries(
    [".upper.left", ".forearm.left", ".upper.right", ".forearm.right"].map(
      (selector) => {
        const element = get(selector);
        return [
          selector,
          { element, height: selector.includes("forearm") ? 15 : 18 },
        ];
      },
    ),
  );
  const yarn = Object.fromEntries(
    [".finger-yarn", ".stitch-yarn", ".feed-yarn"].map((selector) => [
      selector,
      get(selector),
    ]),
  );
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let frame;
  let last;
  let elapsed = 0;

  function connect(element, a, b, height = 0) {
    const dx = b[0] - a[0];
    const dy = b[1] - a[1];
    element.style.left = `${a[0]}px`;
    element.style.top = `${a[1] - height / 2}px`;
    element.style.width = `${Math.hypot(dx, dy)}px`;
    element.style.transform = `rotate(${Math.atan2(dy, dx)}rad)`;
  }
  function limb(selector, a, b) {
    const { element, height } = limbs[selector];
    connect(element, a, b, height);
  }
  function draw(phase) {
    let index = 0;
    while (index < poses.length - 2 && phase > poses[index + 1].p) index++;
    const a = poses[index];
    const b = poses[index + 1];
    const progress = (phase - a.p) / (b.p - a.p);
    const eased = progress * progress * (3 - 2 * progress);
    const x = a.x + (b.x - a.x) * eased;
    const y = a.y + (b.y - a.y) * eased;
    const angle = a.angle + (b.angle - a.angle) * eased;
    const pull = Math.sin(phase * Math.PI * 2);
    const left = [111 + pull * 0.7, 216 - Math.max(0, -pull) * 1.4];
    limb(".upper.left", [57, 182], [66, 214]);
    limb(".forearm.left", [66, 214], left);
    limb(".upper.right", [191, 182], [187, 217]);
    limb(".forearm.right", [187, 217], [x, y]);
    support.style.left = `${left[0]}px`;
    support.style.top = `${left[1]}px`;
    support.style.transform = "rotate(-8deg)";
    hand.style.left = `${x}px`;
    hand.style.top = `${y}px`;
    tool.style.transform = `rotate(${angle}deg)`;
    // All yarn endpoints share the hand coordinates, keeping it attached during motion.
    const radians = (angle * Math.PI) / 180;
    const tip = [x - 36 * Math.cos(radians), y - 36 * Math.sin(radians)];
    const finger = [left[0] - 5, left[1] - 18];
    connect(yarn[".finger-yarn"], finger, tip);
    connect(yarn[".stitch-yarn"], tip, [112, 222]);
    connect(yarn[".feed-yarn"], [204, 277], finger);
    loop.style.height = phase > 0.37 && phase < 0.79 ? "12px" : "7px";
    loop.style.opacity = phase > 0.12 ? 1 : 0.65;
    blanket.style.transform = `translateY(${-Math.max(0, -pull) * 0.9}px) rotate(${-Math.max(0, -pull) * 0.3}deg)`;
  }
  function tick(now) {
    if (last !== undefined) elapsed += now - last;
    last = now;
    draw((elapsed % 2400) / 2400);
    frame = requestAnimationFrame(tick);
  }
  function sync() {
    cancelAnimationFrame(frame);
    last = undefined;
    if (reducedMotion.matches) draw(0);
    if (!paused && !reducedMotion.matches && !document.hidden)
      frame = requestAnimationFrame(tick);
  }
  draw(0);
  sync();
  reducedMotion.addEventListener("change", sync);
  document.addEventListener("visibilitychange", sync);
  return () => {
    cancelAnimationFrame(frame);
    reducedMotion.removeEventListener("change", sync);
    document.removeEventListener("visibilitychange", sync);
  };
}
